function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMildBlueWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.67 56.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2",
    "data-name": "Vrstva 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.93 26.95 124.93 10.57 117.69 10.57 117.69 14.58 120.4 14.58 120.4 26.95 124.93 26.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.14,27V17.44a2.59,2.59,0,0,1,2.56-2.89c1.41,0,2.47,1,2.47,2.89V27h4.56V15.88a5.64,5.64,0,0,0-5.84-5.71,5.24,5.24,0,0,0-4.56,2.39H104a4.71,4.71,0,0,0-4.34-2.39,4.38,4.38,0,0,0-3.75,1.89h-.34V10.57H91V55h4.56V53.44h.34a5.17,5.17,0,0,0,4.43,1.92c4.25,0,7.68-3.69,7.68-8.6s-3.18-8.58-7.43-8.58a5.66,5.66,0,0,0-4.68,2.08h-.34V17.38a2.6,2.6,0,0,1,2.53-2.83A2.39,2.39,0,0,1,100.61,17V27ZM99.46,42.5a4,4,0,0,1,3.93,4.29,4,4,0,1,1-7.89,0A4,4,0,0,1,99.46,42.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.67,46.76c0-4.85-3.15-8.58-8.21-8.58a8.3,8.3,0,0,0-8.39,8.61,8.23,8.23,0,0,0,8.52,8.57c3.18,0,6.37-1.36,7.55-5l-4.06-.93a3.7,3.7,0,0,1-3.56,2,3.45,3.45,0,0,1-3.77-3.44h11.92Zm-11.89-1.87a3.6,3.6,0,0,1,3.68-3,3.5,3.5,0,0,1,3.62,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,27.35a5.15,5.15,0,0,0,4.43-1.93h.34V27h4.56V3.64H153.6v8.61h-.34a5.62,5.62,0,0,0-4.68-2.08c-4.25,0-7.43,3.79-7.43,8.57S144.58,27.35,148.83,27.35Zm.87-12.86a4,4,0,0,1,4,4.28,4,4,0,1,1-7.9,0A4,4,0,0,1,149.7,14.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22,48.09A2.76,2.76,0,0,1,131.41,51a2.7,2.7,0,0,1-2.72-2.86V38.58h-4.56v11a5.61,5.61,0,0,0,5.78,5.78,4.72,4.72,0,0,0,4-1.89h.32V55h4.55V38.58h-4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.48 7.71 131.48 22.94 128.61 22.94 128.61 26.98 138.91 26.98 138.91 22.94 136.04 22.94 136.04 7.76 139.13 7.76 139.13 3.67 131.48 3.67 131.48 7.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.81 36.02 117.81 31.98 110.16 31.98 110.16 36.07 113.25 36.07 113.25 51.24 110.38 51.24 110.38 55.28 120.68 55.28 120.68 51.24 117.81 51.24 117.81 36.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.84,8.7a4.35,4.35,0,1,0-4.37-4.35A4.35,4.35,0,0,0,121.84,8.7Zm0-6.28a1.94,1.94,0,1,1-1.94,1.93A1.94,1.94,0,0,1,121.84,2.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.17,6.94C50.23,8.44,39.1,15.28,33.09,27.41L0,5v50.6L2.61,55l.46-.1c14.85-3.27,25.46-10.34,31.66-21.18L69,57V6.69l-2.34.21ZM31,31.56l-.19.32a35,35,0,0,1-8.33,9.68V31l-4.32-2.16V44.58a41.75,41.75,0,0,1-4.31,2.27V25.54L9.55,23.26V48.6q-2.48.88-5.19,1.57H4.31V13.12L31.14,31.31ZM64.69,48.84l-28-19,.08-.17.15-.32a30.22,30.22,0,0,1,9-10.95v11l4.31,2.48V15.71a36,36,0,0,1,4.93-2.11V35.3l4.31,2.16V12.37q2.34-.54,4.89-.87l.35-.05Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMildBlueWhite);
export default __webpack_public_path__ + "static/media/mild-blue-white.c02c2a47647d586a539e5f4875eeb1cd.svg";
export { ForwardRef as ReactComponent };